;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import {
  GROUP_TYPE_WORKSHOP,
  GROUP_TYPE_THERAPY_GROUP,
  GROUP_TYPE_SUPPORT_GROUP,
  GROUP_TYPE_RETREATS,
  GROUP_TYPE_CLINICAL_PEER_GROUP,
} from "../../../shared/constants"
import groupOrbOpen from "../../../shared/icons/groupOrbOpen.svg"
import retreatsIcon from "../../../../../common/icons/assets/retreats-icon.svg"
import supportGroupIcon from "../../../../../common/icons/assets/support-group-icon.svg"
import therapyGroupIcon from "../../../../../common/icons/assets/therapy-group-icon.svg"
import workshopIcon from "../../../../../common/icons/assets/workshop-icon.svg"
import clinicalPeerGroupIcon from "../../../../../common/icons/assets/clinical-peer-group-icon.svg"
import styles from "./styles.module.scss"
import SvgIcon from "@mui/material/SvgIcon"
import { UI_STYLE_PRIMARY_BLUE_BLACK } from "../../../../../../lib/constants"

const GROUP_TYPE_DETAILS = {
  [GROUP_TYPE_WORKSHOP]: {
    icon: workshopIcon,
    viewBox: "0 0 90 90",
    label: "WORKSHOPS",
    description: "Skill building",
    definition:
      "Group work defined by skill building where participants get hands on practice implementing skills on a specific subject.",
    iconClosedCustomStyle: "top-[1px]",
    iconOpenCustomStyle: "top-[1px] transform scale-x-[-1] left-0",
    iconDesktopWidth: "95px",
    iconDesktopHeight: "95px",
    iconMobileWidth: "63px",
    iconMobileHeight: "63px",
  },
  [GROUP_TYPE_THERAPY_GROUP]: {
    icon: therapyGroupIcon,
    viewBox: "0 0 1200 1200",
    label: "THERAPY GROUPS",
    description: "Interpersonal processing",
    definition:
      "Group work defined by interpersonal processing facilitated by a licensed clinician.",
    iconClosedCustomStyle: "top-[-23px] min-[600px]:top-[-25px]",
    iconOpenCustomStyle:
      "top-[-23px] min-[600px]:top-[-25px] left-0 min-[600px]:left-[-25px]",
    iconDesktopWidth: "144px",
    iconDesktopHeight: "146px",
    iconMobileWidth: "95px",
    iconMobileHeight: "113px",
  },
  [GROUP_TYPE_SUPPORT_GROUP]: {
    icon: supportGroupIcon,
    viewBox: "0 0 1200 1200",
    label: "SUPPORT GROUPS",
    description: "Shared experiences",
    definition:
      "Group work defined by creating space to come together around a shared experience the participants have in common.",
    iconClosedCustomStyle: "top-[-18px] min-[600px]:top-[-30px]",
    iconOpenCustomStyle:
      "transform scale-x-[-1] top-[-18px] min-[600px]:top-[-30px] left-0 min-[600px]:left-[-25px]",
    iconDesktopWidth: "144px",
    iconDesktopHeight: "144px",
    iconMobileWidth: "97px",
    iconMobileHeight: "97px",
  },
  [GROUP_TYPE_RETREATS]: {
    icon: retreatsIcon,
    viewBox: "0 0 1200 1200",
    label: "RETREATS",
    description: "Focused getaway",
    definition:
      "Group work defined by a focused getaway  temporarily withdrawing from routine in order to concentrate purposefully.",
    iconClosedCustomStyle: "top-[-15px] min-[600px]:top-[-25px]",
    iconOpenCustomStyle:
      "top-[-15px] min-[600px]:top-[-25px] left-0 min-[600px]:left-[-39px]",
    iconDesktopWidth: "144px",
    iconDesktopHeight: "144px",
    iconMobileWidth: "95px",
    iconMobileHeight: "95px",
  },
  [GROUP_TYPE_CLINICAL_PEER_GROUP]: {
    icon: clinicalPeerGroupIcon,
    viewBox: "0 0 1200 1200",
    label: "CLINICAL PEER GROUPS",
    description: "Consultation or supervision",
    definition:
      "Group work for clinicians committed to learning and growing as mental health professionals.",
    iconClosedCustomStyle: "top-[-3px] min-[600px]:top-[-10px]",
    iconOpenCustomStyle:
      "top-[-3px] min-[600px]:top-[-10px] left-0 min-[600px]:left-[-5px]",
    iconDesktopWidth: "100px",
    iconDesktopHeight: "102px",
    iconMobileWidth: "63px",
    iconMobileHeight: "63px",
  },
}

function GroupTypeOrb({ groupType, groupTypeOrbOpen, setGroupTypeOrbOpen }) {
  const getGroupTypeDetail = (property) => GROUP_TYPE_DETAILS[groupType][property]

  const renderIcon = (opened = false) => {
    return (
      <div
        className={`absolute 
        ${opened ? "absolute top-0 left-0 z-10 min-[600px]:z-auto" : ""}
        ${
          opened
            ? getGroupTypeDetail("iconOpenCustomStyle")
            : getGroupTypeDetail("iconClosedCustomStyle")
        }`}
      >
        <SvgIcon
          aria-label={`${groupType}-icon`}
          component={getGroupTypeDetail("icon")}
          viewBox={getGroupTypeDetail("viewBox")}
          sx={{
            color: UI_STYLE_PRIMARY_BLUE_BLACK,
            width: getGroupTypeDetail("iconMobileWidth"),
            height: getGroupTypeDetail("iconMobileHeight"),
            "@media only screen and (min-width: 600px)": {
              width: getGroupTypeDetail("iconDesktopWidth"),
              height: getGroupTypeDetail("iconDesktopHeight"),
            },
          }}
          key={`${groupType}-group-type-org`}
        />
      </div>
    )
  }

  const renderOrb = () => (
    <div className={styles["orb"]}>{getGroupTypeDetail("label")}</div>
  )

  const renderDescription = () => (
    <div className={styles["description"]}>{getGroupTypeDetail("description")}</div>
  )
  const renderOpenOrbWithDefinition = () => (
    <div className={`relative flex flex-col items-center w-full`}>
      {renderOpenOrb()}
      <div
        className={`absolute top-[11px] left-0 px-[20px] flex flex-col justify-start`}
      >
        <div
          className={
            "font-bebas text-black tracking-[.95px] text-[17px] min-[600px]:text-[19px] flex justify-center"
          }
        >
          {getGroupTypeDetail("label")}
        </div>
        <div
          className={
            "font-roboto text-[#737373] tracking-[.3px] text-[16px] min-[600px]:tracking-[.54px] leading-[20px] min-[600px]:text-[18px] min-[600px]:w-[156px]"
          }
        >
          {getGroupTypeDetail("definition")}
        </div>
      </div>
    </div>
  )

  const renderGroupOrbUnopened = () => (
    <div
      className={
        "relative flex flex-col items-center pt-[50px] min-[600px]:pt-[75px] h-[199px] min-[600px]:h-[270px]"
      }
      onMouseEnter={() => setGroupTypeOrbOpen(groupType)}
      onMouseLeave={() => setGroupTypeOrbOpen(false)}
      onClick={() => setGroupTypeOrbOpen(groupType)}
    >
      {renderIcon()}
      {renderOrb()}
      {renderDescription()}
    </div>
  )

  const renderGroupOrbOpened = () => (
    <div
      className={
        "relative flex flex-col items-center pt-[50px] min-[600px]:pt-[75px] h-[199px] min-[600px]:h-[270px] w-[200px] items-start"
      }
      onMouseEnter={() => setGroupTypeOrbOpen(groupType)}
      onMouseLeave={() => setGroupTypeOrbOpen(false)}
      onClick={() => setGroupTypeOrbOpen(groupType)}
    >
      {renderIcon(true)}
      {renderOpenOrbWithDefinition()}
    </div>
  )
  const renderOpenOrb = () => {
    return [
      <div
        className={`absolute top-0 left-0 hidden min-[600px]:block`}
        key={"group-orb-open"}
      >
        <SvgIcon
          aria-label={"group-orb-open"}
          component={groupOrbOpen}
          viewBox="0 0 200 226"
          sx={{
            // color: UI_STYLE_PRIMARY_BLUE_BLACK,
            fill: "none",
            "@media only screen and (min-width: 600px)": {
              width: "200px",
              height: "226px",
            },
            width: "200px",
            height: "226px",
          }}
          key={"retreats-group-type-org"}
        />
      </div>,
      <div
        className={
          "h-[187px] w-[180px] bg-[#06B4FF] min-[600px]:hidden rounded-[20px] "
        }
        key={"group-orb-closed"}
      ></div>,
    ]
  }

  return groupTypeOrbOpen ? renderGroupOrbOpened() : renderGroupOrbUnopened()
}
export default GroupTypeOrb
